export const slides = [
  {
    id: 1,
    image: "/images/agentic-AI.png",
    title: " ",
    subtitle: " ",
    description:
      " ",
  },
  {
    id: 2,
    image: "/images/chat-development.png",
    title: " ",
    subtitle: " ",
    description:
      " ",
  },
  // {
  //   id: 3,
  //   image: "/images/ai4.png",
  //   title: " ",
  //   subtitle: "",
  //   description:
  //     " ",
  // },
  {
    id: 4,
    image: "/images/AI.png",
    title: " ",
    subtitle: " ",
    description:
      " ",
  },
];

export const slidesTeam = [
  {
    id: 1,
    image: "/images/team/team-1.jpg",
    name: "Andrew",
    surname: "Max Fetcher",
    designation: "CEO, techwix",
    social: {
      facebook: "https://www.facebook.com/",
      twitter: "https://twitter.com/",
      linkedin: "https://www.linkedin.com/",
      instagram: "https://www.instagram.com/",
    },
  },
  {
    id: 2,
    image: "/images/team/team-2.jpg",
    name: "Arnold",
    surname: "human",
    designation: "CEO, techwix",
    social: {
      facebook: "https://www.facebook.com/",
      twitter: "https://twitter.com/",
      linkedin: "https://www.linkedin.com/",
      instagram: "https://www.instagram.com/",
    },
  },
  {
    id: 3,
    image: "/images/team/team-3.jpg",
    name: "Mike",
    surname: "Holder",
    designation: "CEO, techwix",
    social: {
      facebook: "https://www.facebook.com/",
      twitter: "https://twitter.com/",
      linkedin: "https://www.linkedin.com/",
      instagram: "https://www.instagram.com/",
    },
  },
  {
    id: 4,
    image: "/images/team/team-3.jpg",
    name: "Joakim",
    surname: "Ken",
    designation: "CEO, techwix",
    social: {
      facebook: "https://www.facebook.com/",
      twitter: "https://twitter.com/",
      linkedin: "https://www.linkedin.com/",
      instagram: "https://www.instagram.com/",
    },
  },
  {
    id: 5,
    image: "/images/team/team-2.jpg",
    name: "Joakim",
    surname: "Ken",
    designation: "CEO, techwix",
    social: {
      facebook: "https://www.facebook.com/",
      twitter: "https://twitter.com/",
      linkedin: "https://www.linkedin.com/",
      instagram: "https://www.instagram.com/",
    },
  },
];

export const slidesTestimonail = [
  {
    id: 1,
    image: "/images/testi-3.jpg",
    icon: "/images/testi-icon.png",
    name: "Ravi Malhotra",
    designation: "Founder, ChainX Solutions",
    description:
      "Their expertise in building decentralized exchanges is unmatched. The team delivered a secure and scalable DEX for us, right on schedule. Highly recommend them for any serious blockchain project.",
  },
  {
    id: 2,
    image: "/images/testi-4.jpg",
    icon: "/images/testi-icon.png",
    name: "Fatima Al Mansoori",
    designation: "CTO, Gulf Crypto Fund",
    description:
      "We partnered with them to build a custom liquidity bot, and the results were outstanding. It integrates seamlessly with multiple exchanges and significantly improved our trading efficiency.",
  },
  {
    id: 3,
    image: "/images/testi-3.jpg",
    icon: "/images/testi-icon.png",
    name: " Alexei D",
    designation: "CEO, NFTSocial.io",
    description:
      "From initial consultation to final deployment, their support was top-notch. Our NFT marketplace went live without a hitch, and user feedback has been incredible.",
  },
  {
    id: 4,
    image: "/images/testi-3.jpg",
    icon: "/images/testi-icon.png",
    name: "Michael Tan",
    designation: " Product Lead, BitVault Exchange",
    description:
      "The team delivered a full-stack centralized exchange with robust KYC, admin tools, and real-time trading — all within a tight deadline. True professionals in the crypto space.",
  },
  {
    id: 5,
    image: "/images/testi-3.jpg",
    icon: "/images/testi-icon.png",
    name: "Sara Khan",
    designation: "Co-Founder, MetaHub Innovations",
    description:
      "They helped us transition from Web2 to Web3 by building a custom DApp and wallet integration. Their understanding of smart contracts and UI/UX design is exactly what we needed."
  },
];

export const slidesTestimonailPage = [
  {
    id: 1,
    image: "/images/testi-3.jpg",
    icon: "/images/testi-icon2.png",
    name: "John Doe",
    designation: "CEO, Company",
    description:
      "Accelerate innovation with world-className tech teams. We’ll match you to an entire remote team of incredible freelance talent for all your needs.",
  },
  {
    id: 2,
    image: "/images/testi-4.jpg",
    icon: "/images/testi-icon2.png",
    name: "John Doe",
    designation: "CEO, Company",
    description:
      "Accelerate innovation with world-className tech teams. We’ll match you to an entire remote team of incredible freelance talent for all your needs.",
  },
  {
    id: 3,
    image: "/images/testi-3.jpg",
    icon: "/images/testi-icon2.png",
    name: "John Doe",
    designation: "CEO, Company",
    description:
      "Accelerate innovation with world-className tech teams. We’ll match you to an entire remote team of incredible freelance talent for all your needs.",
  },
];

export const slidesTestimonail3 = [
  {
    id: 1,

    icon: "/images/testi-icon.png",
    name: "Mike Holder",
    designation: "CEO, Company",
    description:
      "Accelerate innovation with world-className tech teams. We’ll match you to an entire remote team of incredible freelance talent for all your needs.",
  },
  {
    id: 2,

    icon: "/images/testi-icon.png",
    name: "Mike Holder",
    designation: "CEO, Company",
    description:
      "Accelerate innovation with world-className tech teams. We’ll match you to an entire remote team of incredible freelance talent for all your needs.",
  },
  {
    id: 3,

    icon: "/images/testi-icon.png",
    name: "Mike Holder",
    designation: "CEO, Company",
    description:
      "Accelerate innovation with world-className tech teams. We’ll match you to an entire remote team of incredible freelance talent for all your needs.",
  },
];

export const slidesBrand = [
  {
    id: 1,
    image: "/images/brand/brand-1.png",
  },
  {
    id: 2,
    image: "/images/brand/brand-2.png",
  },
  {
    id: 3,
    image: "/images/brand/brand-3.png",
  },
  {
    id: 4,
    image: "/images/brand/brand-4.png",
  },
  {
    id: 5,
    image: "/images/brand/brand-5.png",
  },
  {
    id: 6,
    image: "/images/brand/brand-3.png",
  },
];
